import { lifecycleStatusEnum } from "kubb";
import type React from "react";
import type { Asset } from "utils/object";

export default function AssetRetirementBadge(props: {
  asset: Asset;
}): React.ReactElement | null {
  const { asset } = props;

  if (asset.status !== lifecycleStatusEnum.RETIRED) {
    return null;
  }

  return (
    <span className="inline-flex items-center rounded-md bg-gray-400 px-2 py-1 text-xs font-medium text-white dark:bg-gray-600">
      Retired
    </span>
  );
}
